export default __webpack_public_path__ + "static/media/feedback_good_01.f9f32209.png";